import { z } from "zod";
import { format, isAfter, parseISO } from "date-fns";

// Valores padrão usando date-fns
const now = new Date();
const dateStart = format(now, "yyyy-MM-dd'T'00:00");
const dateEnd = format(now, "yyyy-MM-dd'T'23:59");

export const defaultValues = {
	id_pausa_programada: 0,
	id_empresa: 0,
	data_inicio: dateStart,
	data_fim: dateEnd,
	motivo: "",
	tipo: "AMBOS",
	ativo: true,
};

export const schema = z
	.object({
		id_pausa_programada: z.union([z.string(), z.number()]).transform((val) => Number(val)),
		id_empresa: z.union([z.string(), z.number()]).transform((val) => Number(val)),
		data_inicio: z.string().min(1, "Obrigatório"),
		data_fim: z.string().min(1, "Obrigatório"),
		motivo: z.string().trim().min(1, "Motivo é obrigatório").max(200, "Máximo de 200 caracteres"),
		tipo: z.enum(["LOJA", "DELIVERY", "AMBOS"], {
			errorMap: () => ({ message: "Selecione um tipo: Loja, Delivery ou Ambos" }),
		}),
		ativo: z.boolean(),
	})
	.refine(
		(data) => {
			try {
				const start = parseISO(data.data_inicio);
				const end = parseISO(data.data_fim);
				// Verifica se o fim é depois do início
				return isAfter(end, start);
			} catch (e) {
				return false;
			}
		},
		{
			message: "A data de término deve ser posterior à data de início",
			path: ["data_fim"],
		}
	);
